import { ICountry, IPaymentFields, IPaymentMethod, IShipwallet, ISteps, RootState } from '@checkout/state';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CheckoutForm, Step } from '..';
import { IStepsConfig } from '../../../config/contextCheckoutConfig.d';
import { shipwalletStepRequest } from '../../../reducers/checkout';
import * as Styles from './Steps.scss';
import { getStepsList } from './StepsList';

const isEqual = require('react-fast-compare');

interface IOwnProps {
  stepsContextConfig: IStepsConfig;
}

interface IConnectedProps {
  steps: ISteps;
  fields: IPaymentFields;
  shipwallet: IShipwallet;
  paymentMethods: IPaymentMethod[];
  countries: ICountry[];
  country: string | null;
}

interface IConnectetDispatchProps {
  shipwalletStepRequest: typeof shipwalletStepRequest;
}

interface IState {
  current: number;
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class Steps extends React.Component<Props, IState> {

  shouldComponentUpdate(nextProps: Props) {
    return !isEqual(this.props.steps, nextProps.steps) ||
      !isEqual(this.props.fields, nextProps.fields) ||
      (this.props.intl.locale !== nextProps.intl.locale) ||
      (this.props.country !== nextProps.country);
  }

  render() {
    const { intl, fields, shipwallet, steps, paymentMethods, stepsContextConfig } = this.props;
    const stepsList = getStepsList(shipwallet, intl, fields, paymentMethods, stepsContextConfig.isIngridFieldsVisible);
    // Filter steps to render on the page
    const stepsToRender = stepsList.filter((step) => step.shouldRender);

    return (
      <div className={Styles.steps}>
        <CheckoutForm stepsList={stepsToRender}>
          {stepsToRender.map((step, index) => {
            const stepNumber = index + 1;
            const { ...props } = step.component;

            // Wrap with HOC asStep component
            const WrappedAsStep = Step<any>(step.component);

            return (
              <WrappedAsStep
                key={stepNumber}
                stepNumber={stepNumber}
                active={stepNumber === steps.current}
                completed={steps.current > stepNumber}
                last={stepsList.length === stepNumber}
                {...step}
                {...props}
              />
            );
          })}
        </CheckoutForm>
      </div>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({
      fields: state.checkout.paymentFields,
      steps: state.checkout.steps,
      shipwallet: state.checkout.selection.shipwallet,
      paymentMethods: state.checkout.paymentMethods,
      countries: state.checkout.countries,
      country: state.checkout.location.country && state.checkout.location.country,
    }),
    {
      shipwalletStepRequest
    }
  ),
)(Steps);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/Steps/Steps.tsx